<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>
  @let formGroup = $formGroup();
  <unity-card-new-shared actionName="Create" [formGroup]="formGroup" [formLoading]="$formLoading()" (submitEvent)="onSubmit()">
    <unity-textbox-control
      displayName="Business Partner Name"
      description="Provide the business partner's name."
      [control]="formGroup.controls.name" />
    <unity-textbox-control
      displayName="Business Partner Code"
      description="Provide a business partner code."
      [control]="formGroup.controls.code" />
    <unity-textbox-control displayName="Contact Name" description="Provide a contact name." [control]="formGroup.controls.contact" />
    <unity-textbox-phone-control displayName="Contact Phone" description="Provide a contact phone." [control]="formGroup.controls.phone" />
    <unity-textbox-control displayName="Contact Email" description="Provide a contact email." [control]="formGroup.controls.email" />
    <unity-multiselect-community-control
      description="Select the communities that this business partner serves."
      [control]="formGroup.controls.community_ids" />
    <ng-content submit-options>
      <unity-action-cancel-shared [disabled]="false" [action]="returnToDashboardAction" />
    </ng-content>
  </unity-card-new-shared>
</unity-page-container>
